import { getEnumValues } from './get-enum-values';
export enum CourseStaffRole{
	Owner = 'owner',
	Instructor = 'instructor',
	Mentor = 'mentor',
}
export const CourseStaffRoleValues = getEnumValues<CourseStaffRole>(CourseStaffRole)